import React from "react";
import Button from '@mui/material/Button';
import { ValidateTankPhysicalAdminFuncInput } from "./ValidateTankPhysicalAdminFuncInput";
const btnsArray = [{ operation: "Delete" }, { operation: "Cancel" }];

export default function OverviewButtons({
  tankPhysical,
  navigate,
  _tankPhysicalExist,
  _createErrorMessage,
  _deleteTankPhysical,
}) {
  const onClick = (operation) => {
    if (operation === "Cancel") {
      let navigationNextUrl = `/TankPhysicalOverview`;
      navigate(navigationNextUrl);
      return;
    }

    let validationTankPhysicalResult = ValidateTankPhysicalAdminFuncInput(
      tankPhysical,
      _createErrorMessage
    );

    if (!validationTankPhysicalResult) {
      return;
    }

    _tankPhysicalExist({ data: { Id: tankPhysical } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("111");
        return;
      }
      _deleteTankPhysical({ data: { Id: tankPhysical } });

    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => onClick(operation, noValidation, navPath)}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
